import { render, staticRenderFns } from "./relitu.vue?vue&type=template&id=182360f4&scoped=true"
import script from "./relitu.vue?vue&type=script&lang=js"
export * from "./relitu.vue?vue&type=script&lang=js"
import style0 from "./relitu.vue?vue&type=style&index=0&id=182360f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182360f4",
  null
  
)

export default component.exports